import type { FaireProductEntity } from "../../entity_types/product";

export const p_dn8sngcncu: FaireProductEntity = {
  token: "p_dn8sngcncu",
  type: "product",
  name: "Lillian Rose Wedding Ring Book Box",
  brandToken: "b_3ii405yp",
  brandName: "Lillian Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/fb47f0d1469a671cda87dc2e0d0e9abd0d7fd99ed3b7479f28a483f75016d158.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c07c51c962ff27c7e79e67d681d62985b2a4c7799a6e001f405fe799613f8efa.jpeg",
    "https://cdn.faire.com/fastly/2205d6bf1d34e0a4bc03222d2f3dc159a9b8942f1155e4e4de21aadab7ecc683.jpeg",
    "https://cdn.faire.com/fastly/c1e733b70fa6027d521fe7841b3cb2d680428e8da2cc61ad0672f000ff2089c1.jpeg",
  ],
  priceDollars: 9.93,
  description:
    "This traditional yet unique ring box made to look like a small book is the perfect ring box for proposal or exchanging rings at the wedding ceremony. The book box is the perfect alternative to a traditional ring pillow or a ring bearer box. Inside the book, the cover has a special velvet pocket for holding the rings. The book is decorated with a delicate metallic gold foil design making it a beautiful accessory for the wedding day ceremony and a lovely keepsake. The box measures a height of 3.75 inches, a width of 2.75 inches, and a depth of 1.25 inches.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:42.467Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
